import { ReactNode, createContext, useContext, useState } from "react";
import { useTranslation } from "react-i18next";

type ILayoutInf = {
  title: string;
  step: number;
};
interface JoinContextType {
  joinStep: number;
  setJoinStep: (joinStep: number) => void;
  joinInf: any;
  setJoinInf: (joinInf: any) => void;
  onJoinInf(inf: any): void;
}

export const JoinContext = createContext<JoinContextType | undefined>(
  undefined
);

interface IJoinProvider {
  children: ReactNode;
}

export const JoinProvider = ({ children }: IJoinProvider) => {
  const { t } = useTranslation();

  const [joinStep, setJoinStep] = useState(() => {
    const step = localStorage.getItem("joinStep");

    if (step) {
      return JSON.parse(step);
    }
    return 1;
  });

  const [joinInf, setJoinInf] = useState<any>(() => {
    const inf = localStorage.getItem("joinInf");
    if (inf) {
      return JSON.parse(inf);
    }
  });

  const [btnAble, setBtnAble] = useState({});

  const onJoinInf = (inf: any) => {
    setJoinInf({
      ...joinInf,
      ...inf,
    });

    localStorage.setItem(
      "joinInf",
      JSON.stringify({
        ...joinInf,
        ...inf,
      })
    );
  };

  return (
    <JoinContext.Provider
      value={{
        joinStep,
        setJoinStep,
        joinInf,
        setJoinInf,
        onJoinInf,
      }}
    >
      {children}
    </JoinContext.Provider>
  );
};

export const useJoinContext = (): JoinContextType => {
  const context = useContext(JoinContext);
  if (!context) {
    throw new Error("useAuthContext GridProvider 내에서만 사용해야 합니다.");
  }

  return context;
};
